export default "__VITE_ASSET__B7bemwbD__"